import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import PropTypes from 'prop-types';
import React from 'react';
import { useCalculateTopOffset } from '../../../hooks/useCalculateTopOffset';
import { Appbar } from '../../Appbar';
import { AppbarUser } from '../../AppbarUser';
import { Clientbar } from '../../Clientbar';
import { Sidebar, SidebarMenu, SidebarMenuItem } from '../../Sidebar';
import TopOffsetContextProvider from '../../TopOffsetContextProvider';
import { passSx, sxPropType } from '../../utils';
import { MainStyle } from '../Dashboard';
const defaultSidebar = /*#__PURE__*/ React.createElement(SidebarMenu, {
    title: /*#__PURE__*/ React.createElement(Skeleton, null)
}, /*#__PURE__*/ React.createElement(SidebarMenuItem, {
    title: /*#__PURE__*/ React.createElement(Skeleton, null)
}), /*#__PURE__*/ React.createElement(SidebarMenuItem, {
    title: /*#__PURE__*/ React.createElement(Skeleton, null)
}));
const defaultContent = /*#__PURE__*/ React.createElement(Grid, {
    container: true,
    rowSpacing: 4
}, /*#__PURE__*/ React.createElement(Grid, {
    size: {
        xs: 8
    }
}, /*#__PURE__*/ React.createElement(Grid, {
    container: true,
    rowSpacing: 2
}, /*#__PURE__*/ React.createElement(Grid, {
    size: {
        xs: 12
    }
}, /*#__PURE__*/ React.createElement("h3", null, /*#__PURE__*/ React.createElement(Skeleton, {
    variant: "rectangular",
    height: 50
}))), /*#__PURE__*/ React.createElement(Grid, {
    size: {
        xs: 12
    }
}, /*#__PURE__*/ React.createElement(Skeleton, {
    variant: "rectangular",
    height: 40
})), /*#__PURE__*/ React.createElement(Grid, {
    size: {
        xs: 12
    }
}, /*#__PURE__*/ React.createElement(Grid, {
    container: true,
    direction: "row",
    columnSpacing: 4
}, /*#__PURE__*/ React.createElement(Grid, {
    size: {
        xs: 6
    }
}, /*#__PURE__*/ React.createElement(Skeleton, {
    variant: "rectangular",
    height: 40
})), /*#__PURE__*/ React.createElement(Grid, {
    size: {
        xs: 6
    }
}, /*#__PURE__*/ React.createElement(Skeleton, {
    variant: "rectangular",
    height: 40
})))), /*#__PURE__*/ React.createElement(Grid, {
    size: {
        xs: 12
    }
}, /*#__PURE__*/ React.createElement(Skeleton, {
    variant: "rectangular",
    height: 40
})), /*#__PURE__*/ React.createElement(Grid, {
    size: {
        xs: 12
    }
}, /*#__PURE__*/ React.createElement(Skeleton, {
    variant: "rectangular",
    height: 40
})), /*#__PURE__*/ React.createElement(Grid, {
    size: {
        xs: 12
    }
}, /*#__PURE__*/ React.createElement(Skeleton, {
    variant: "rectangular",
    height: 40
})))));
const DashboardLoaderSkeleton = ({ AppbarProps, sx, sidebarElement = defaultSidebar, children = defaultContent, clientBarElement, ClientbarProps, SidebarProps })=>{
    const { topOffset, appBarRef, clientBarRef } = useCalculateTopOffset();
    return /*#__PURE__*/ React.createElement(TopOffsetContextProvider, {
        topOffset: topOffset
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: [
            {
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh'
            },
            ...passSx(sx)
        ]
    }, /*#__PURE__*/ React.createElement(Appbar, {
        withSidebar: true,
        rightSideElements: [
            /*#__PURE__*/ React.createElement(AppbarUser, {
                key: "appbar"
            })
        ],
        ref: appBarRef,
        ...AppbarProps
    }), clientBarElement && /*#__PURE__*/ React.createElement(Clientbar, {
        ref: clientBarRef,
        ...ClientbarProps
    }, clientBarElement), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            flexGrow: 1
        }
    }, sidebarElement && /*#__PURE__*/ React.createElement(Sidebar, {
        isOpenSidebar: true,
        ...SidebarProps
    }, sidebarElement), /*#__PURE__*/ React.createElement(MainStyle, {
        topOffset: topOffset
    }, children))));
};
DashboardLoaderSkeleton.propTypes = {
    AppbarProps: PropTypes.object,
    ClientbarProps: PropTypes.object,
    SidebarProps: PropTypes.object,
    appbarRightSideElements: PropTypes.node,
    children: PropTypes.node,
    clientBarElement: PropTypes.node,
    sidebarElement: PropTypes.node,
    sx: sxPropType
};
export default DashboardLoaderSkeleton;
